import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import Spinner from "../components/Loader/Spinner";

import { allhostellogin } from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import axios from "../api/constant";
import {
  subassets,
  getAssetsName,
  AddAsset,
  Assetnameinfo,
  AddHostelRequirement,
  getdistrictName,
  getallDistricts,
  getAmenitiesType,
  getdistictName,
  getAllBlocksFromDistrict,
  getGPFromDistrictAndBlock,
  getVillageFromGpBlockAndDistrict,
  getSchoolFromVillage,
  getAmenityCountsData,
  getGCB,
  get_year_of_const,
} from "../api/Users";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import pdfLogo from "../images/login1.png";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const AmenitiesReport = ({ role, userData }) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [AssetsSubTypes, setAssetsSubTypes] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [ExistAssetsType, setExistAssetsType] = useState([]);
  const [markRequired, setMarkRequired] = useState(true);
  const [AssetsType, setAssetsType] = useState("all");
  const [AssetsTypes, setAssetsTypes] = useState([]);
  const [postAmenityName, setPostAmenityName] = useState("");
  const [allYearOfConstruction, setAllYearOfConstruction] = useState([]);

  const [gbcType, setGcbType] = useState("");
  const [gcb, setGcb] = useState([]);
  const [yearsCons, setYearsCons] = useState([]);
  const [yearCons, setYearCons] = useState("");
  const [hostels, setHostels] = useState([]);
  const [hostelType, setHostelType] = useState("");

  const handleHostelType = (event) => {
    setHostelType(event.target.value);
  };

  const handleGCBChange = async (e) => {
    setGcbType(e.target.value);
    const data = {
      UDISE_code: userData.data.UDISE_code,
      gbc_id: e.target.value,
    };
    await axios
      .post("/get_year_of_cons_from_gbc_udise", data)
      .then((response) => {
        if (response.data.status == "success") {
          setYearsCons(response.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching Categories:", err);
      });
  };

  const handleYear = (e) => {
    setYearCons(e.target.value);
    const data = {
      UDISE_code: userData.data.UDISE_code,
      gbc_id: gbcType,
      yoc: e.target.value,
    };
    console.log(data);
    axios
      .post("/get_hostel_type_from_udise_gbc_yoc", data)
      .then((response) => {
        if (response.data.status == "success") {
          setHostels(response.data.data.result);
        }
      })
      .catch((err) => {
        console.error("Error fetching Categories:", err);
      });
  };

  const AssetTypehandle = async (e) => {
    const selectedValue = e.target.value;
    console.log(selectedValue);

    if (!selectedValue) {
      console.error("Empty value received");
      return;
    }

    try {
      const amenities = JSON.parse(selectedValue);
      console.log(amenities);

      const amenityId = amenities.amenity_id;
      setAssetsType(amenityId);

      const amenityName = amenities.name;
      setPostAmenityName(amenityName);

      console.log("AssetsType", amenityId);

      const response = await subassets({ amenity_id: amenityId });
      if (response) {
        console.log(response.data.asset_name);
        setAssetsSubTypes(response.data.asset_name);
      } else {
        console.error("Invalid response format for subassets:", response);
      }
    } catch (error) {
      console.error("Error fetching subassets:", error);
    }
  };

  useEffect(() => {
    getAmenitiesType()
      .then((res) => {
        if (res.status === "success") {
          console.log("amenities data:", res.data);
          setAssetsTypes(res.data);
          setExistAssetsType(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  }, []);

  useEffect(() => {
    getGCB()
      .then((res) => {
        if (res.status === "success") {
          console.log("dis data:", res.data);
          setGcb(res.data.student_gbc_master);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  }, []);

  useEffect(() => {
    getStocksData();
  }, []);

  const getStocksData = () => {
    setIsLoading(true);
    const data = {
      UDISE_code: userData.data.UDISE_code,
      year: yearCons,
      amenity_type: AssetsType,
      hostel_type: hostelType,
    };
    axios
      .post(`/manage_stock`, data)
      .then((response) => {
        if (response.data.status == "success") {
          setFilteredData(response.data.data.result);
          setRows(response.data.data.result);
          setIsLoading(false);
        } else {
          setFilteredData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  };

  // Update filteredData whenever searchQuery changes
  useEffect(() => {
    const filtered = rows.filter(
      (item) =>
        item.hostel_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.school_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.school_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.hostel_category
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        (item.UDISE_code &&
          item.UDISE_code.toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        item.school_catgegory.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredData(filtered);
    setPage(0);
  }, [searchQuery, rows]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let navigate = useNavigate();
  const view = (id) => {
    navigate(`/${role === 5 ? "dealer" : "admin"}/userdetails/${id}`);
  };

  const exportPDF = () => {
    const doc = new jsPDF("landscape", "pt", "letter");

    const title = "SC/ST Department, Odisha";
    const reportName = "Amenity Stocking Report";
    const tableColumn = [
      "Sr. No.",
      "Amenity Type",
      "Amenity Sub Type",
      "Ideal Count",
      "Actual Count",
      "Shortage Count",
    ];
    const tableRows = [];

    // Load your logo (replace 'path/to/your/logo.png' with actual path or base64 string)
    const logoUrl = pdfLogo; // Change this URL or use base64 image data
    doc.addImage(logoUrl, "PNG", 10, 10, 30, 30); // Adjust dimensions as needed

    // Calculate the center position for the title vertically with respect to the logo
    const titleHeight = 10 + 15; // Adjust this depending on your logo's height + some margin
    const titleRepHeight = 10 + 50;
    const titleWidth =
      (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
      const fromLeft = 330; // Adjust depending on the size and placement of your logo
      const fromRepLeft = 40;

    filteredData.forEach((row, index) => {
      const rowData = [
        index + 1,
        row.amenities_type,
        row.amenities_sub_type_name,
        row.ideal_count,
        row.actual_count,
        row.shortage_count,
      ];
      tableRows.push(rowData);
    });

    doc.setFontSize(16); // Sets the font size to 16 points for the title
    doc.text(title, fromLeft, titleHeight); // Position the title next to the logo
    doc.setFontSize(12);
    doc.text(reportName, fromRepLeft, titleRepHeight);
    doc.setFontSize(12); // Resets the font size for the table
    doc.autoTable(tableColumn, tableRows, { startY: 70 }); // Start the table 100px below the logo and title
    doc.save("amenity_stocking_report.pdf");
  };

  const exportExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Amenity Report");

    // Add title
    worksheet.mergeCells("A1:G1");
    const titleRow = worksheet.getRow(1);
    titleRow.getCell(1).value = "Amenity Report";
    titleRow.getCell(1).font = { bold: true, size: 16 };
    titleRow.getCell(1).alignment = { horizontal: "center" };

    // Add headers
    const headers = [
      "Sr. No.",
      "Amenity Type",
      "Amenity Sub Type",
      "Ideal Count",
      "Actual Count",
      "Shortage Count",
    ];
    // worksheet.addRow([]); // Add empty row for spacing
    const headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "003366" }, // Blue background color
      };
      cell.font = {
        color: { argb: "FFFFFF" }, // White text color
        bold: true,
      };
    });

    // Add data
    filteredData.forEach((row, index) => {
      worksheet.addRow([
        index + 1,
        row.amenities_type,
        row.amenities_sub_type_name,
        parseInt(row.ideal_count),
        parseInt(row.actual_count),
        parseInt(row.shortage_count),
      ]);
    });

    // Set workbook properties
    workbook.creator = "Your Name";
    workbook.lastModifiedBy = "Your Name";
    workbook.created = new Date();
    workbook.modified = new Date();

    // Generate Excel file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const fileName = "amenity_stocking_report.xlsx";
      saveAs(blob, fileName);
    });
  };

  const getSerialNumber = (index) => {
    return page * rowsPerPage + index + 1;
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h5 className="mt-4">{t("Amenity Stocking Report")}</h5>
          <div className="mb-3">
            <TextField
              label={t("Search")}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state with the new value
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{
                width: "17rem",
                marginTop: "20px", // Additional style from your existing code
              }}
            />
          </div>
        </div>
        <div className="d-flex col-12 justify-content-start align-items-center">
          <div className="col-md-2 mt-3">
            <label className="form-label">
              {t("GBC Type")}{" "}
              {markRequired && <span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="gbc_type"
              value={gbcType}
              className="common-input form-select"
              onChange={handleGCBChange}
              required
            >
              <option value="">{t("Select GBC Type")}</option>
              {gcb.map((item) => (
                <option value={item.id}>{t(item.type)}</option>
              ))}
            </select>
          </div>

          <div className="col-md-2 mt-3" style={{ marginLeft: "2rem" }}>
            <label className="form-label">
              {t("Year of Construction")}{" "}
              {markRequired && <span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="yearCons"
              className="common-input form-select"
              value={yearCons}
              onChange={handleYear}
              required
            >
              <option value="">{t("Year of Construction")}</option>
              {yearsCons.map((item) => (
                <option value={item.year_of_const}>
                  {t(item.year_of_const)}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-2 mt-3" style={{ marginLeft: "2rem" }}>
            <label className="form-label">
              {t("Hostel Type")}{" "}
              {markRequired && <span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="hostelType"
              className="common-input form-select"
              value={hostelType}
              onChange={handleHostelType}
              required
            >
              <option value="">{t("Select Hostel Type")}</option>
              {hostels.map((item) => (
                <option value={item.hostel_type}>{t(item.hostel_type)}</option>
              ))}
            </select>
          </div>
          <div className="col-md-2 mt-3" style={{ marginLeft: "2rem" }}>
            <label className="form-label">
              {t("Amenity Type")}{" "}
              {markRequired && <span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="asset_type_id"
              className="common-input form-select"
              onChange={AssetTypehandle}
              required
            >
              <option value="all">{t("Select Amenity Type")}</option>
              {/* Map assetOptions to generate option elements */}
              {AssetsTypes.assets_name &&
                AssetsTypes.assets_name.map((row, index) => (
                  <option key={index} value={JSON.stringify(row)}>
                    {row.name}
                  </option>
                ))}
            </select>
          </div>
          <button
            className="btn btn-primary btn-sm mx-5"
            style={{ marginTop: "45px" }}
            onClick={getStocksData}
          >
            Search
          </button>
        </div>

        <div class="col-md-12 mt-4 d-flex">
          <div class="d-flex justify-content-start align-items-center">
            <Button variant="contained" color="primary" onClick={exportPDF}>
              Download PDF
            </Button>
            <span class="mx-2"></span>
            <Button variant="contained" color="success" onClick={exportExcel}>
              Download Excel
            </Button>
          </div>
        </div>

        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">{t("Sr. No.")}</TableCell>
                  <TableCell align="center">{t("Amenity Type")}</TableCell>
                  <TableCell align="center">{t("Amenity Sub Type")}</TableCell>
                  <TableCell align="center">{t("Ideal Count")}</TableCell>
                  <TableCell align="center">{t("Actual Count")}</TableCell>
                  <TableCell align="center">{t("Shortage Count")}</TableCell>
                  {/* <TableCell align="left">{t("Action")}</TableCell> */}
                </TableRow>
              </TableHead>

              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row" align="center">
                          {getSerialNumber(index)}
                        </TableCell>
                        <TableCell align="center">
                          {row.amenities_type}
                        </TableCell>
                        <TableCell align="center">
                          {row.amenities_sub_type_name}
                        </TableCell>
                        <TableCell align="center">{row.ideal_count}</TableCell>
                        <TableCell align="center">{row.actual_count}</TableCell>
                        <TableCell align="center">
                          {row.shortage_count}
                        </TableCell>
                        {/* <TableCell align="left">
                          <button
                            className="btn btn-success btn-sm"
                            onClick={() => view(row.party_code)}
                          >
                            {t("View")}
                          </button>
                        </TableCell> */}
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <h4>
                      {" "}
                      <i>{t("No data available")}</i>{" "}
                    </h4>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default AmenitiesReport;
